import React from 'react';
import './treeMapLegend.css';

/* 
  Legend component for the tree map graph
  < input = onQualityFilterChange, qualityFilter >
 */

function TreeMapLegend({ onQualityFilterChange, qualityFilter }) {
  
  // If active, adds active to className for active state css
  const isQualityActive = (quality) => {
    return quality === qualityFilter ? 'active' : '';
  };

  return (
    <div className="legends-container">
      {/* Red Button  - (Low Quality) */}
      <div className={`legends-inner-container-red-button ${isQualityActive('low-quality')}`}>
        <button
          className="small-red-button"
          onClick={() => onQualityFilterChange('low-quality')}
        >
          <div className="legends-text">Low Quality</div>
        </button>
      </div>

      {/* Orange Button - (Medium Quality) */}
      <div className={`legends-inner-container-orange-button ${isQualityActive('medium-quality')}`}>
        <button
          className="small-orange-button"
          onClick={() => onQualityFilterChange('medium-quality')}
        >
          <div className="legends-text">Medium Quality</div>
        </button>
      </div>

      {/* Green Button - (High Quality) */}
      <div className={`legends-inner-container-green-button ${isQualityActive('high-quality')}`}>
        <button
          className="small-green-button"
          onClick={() => onQualityFilterChange('high-quality')}
        >
          <div className="legends-text">High Quality</div>
        </button>
      </div>
    </div>
  );
}

export default TreeMapLegend;
